module.exports = "https://www.gc-qa.gnp.com.mx/bfa6b7d6aa58a027acd375b14277906d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/user_copy.svg
// module id = 380
// module chunks = 0